<template>
	<div class="app flex-row align-items-center">
		<div class="container">
			<b-row class="justify-content-center">
				<b-col md="8">
					<b-card-group>
						<b-card no-body class="p-4">
							<b-card-body>
								<b-form @submit="login">
									<!--<h1>SPC Telecentinel</h1>-->
									<b-img  center src="../img/brand/LOGO SPC.png" alt="Center image"></b-img>
									<br>
									<p class="text-muted">Inicio de Sesión</p>
									<b-input-group class="mb-3">
										<b-input-group-prepend>
											<b-input-group-text><i class="icon-envelope"></i></b-input-group-text>
										</b-input-group-prepend>
										<b-form-input
											type="email"
											class="form-control"
											placeholder="Correo Electrónico"
											autocomplete="username email"
											v-model="email"
											required/>
									</b-input-group>
									<b-input-group class="mb-4">
										<b-input-group-prepend>
											<b-input-group-text><i class="icon-lock"></i></b-input-group-text>
										</b-input-group-prepend>
										<b-form-input
											type="password"
											class="form-control"
											placeholder="Contraseña"
											autocomplete="current-password"
											v-model="password"
											required/>
									</b-input-group>
									<b-row>
										<b-col v-if="errorMessage" cols="12" class="mb-3">
											<h6 class="text-danger">{{ errorMessage }}</h6>
										</b-col>
										<b-col cols="6">
											<b-button type="submit" v-if="!loading" variant="primary" class="px-4">
												Iniciar Sesión
											</b-button>
											<i v-if="loading" class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
											<span class="sr-only">Loading...</span>
										</b-col>
										<b-col cols="6" class="text-right">
											<router-link :to="{name: 'ForgotPassword'}">¿Olvidó su Contraseña?
											</router-link>
										</b-col>
									</b-row>
								</b-form>
							</b-card-body>
						</b-card>
						<b-card no-body class="text-white bg-primary py-5 d-md-down-none">
							<b-card-body class="text-center">
								<div>
									<h2>Registro de Usuario</h2>
									<p>Si desea crear una cuenta de usuario para ingresar a nuestra aplicación de casos,
										presione el botón a continuación.</p>
									<b-button variant="primary" class="active mt-3" @click="goToSignUp()">Iniciar
										Registro
									</b-button>
								</div>
							</b-card-body>
						</b-card>
					</b-card-group>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Login',
	created() {
		if (this.$store.getters.isLoggedIn) {
			this.$router.push('/')
		}
	},
	data: function () {
		return {
			email: '',
			password: '',
			loading: false,
			errorMessage: ''
		}
	},
	mounted() {
		const token = this.$route.query.token;

		if (typeof token !== 'undefined') {
			console.log(token);
			var base64Url = token.split('.')[1];

			var decodedValue = JSON.parse(window.atob(base64Url));

			this.email = decodedValue.email;
			this.password = decodedValue.password;

			this.beginLogin();
		} else {
			console.error('Token no encontrado....');
		}
	},
	methods: {
		login(evt) {
			evt.preventDefault();

			this.beginLogin();
		},
		beginLogin() {
			this.loading = true;
			this.errorMessage = '';
			let email = this.email;
			let password = this.password;

			this.$store.dispatch("login", {email, password})
				.then(() => {
					this.loading = false;
					this.$router.push('/');
				})
				.catch((err) => {
					this.loading = false;

					if (typeof err.data.Message !== 'undefined') {
						this.errorMessage = err.data.Message;
					}
				});
		},
		goToSignUp() {
			this.$router.push('/pages/register/');
		}
	}
}
</script>
